import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import App from '@/App.vue'
import router from '@/router'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPersist from 'pinia-plugin-persistedstate'
import PrimeVue from 'primevue/config'
import 'primevue/resources/themes/bootstrap4-light-blue/theme.css'
import 'vuetify/styles'
import { aliases, mdi } from 'vuetify/iconsets/mdi' // Optional for MDI icons
import ToastService from 'primevue/toastservice'
// import './aws-exports.';
// import { Amplify } from '@aws-amplify/core';
// import { Auth } from '@aws-amplify/auth';
// import awsconfig from './aws-exports';

// Amplify.configure({ ...awsconfig, Analytics: { disabled: true } });

const pinia = createPinia()
pinia.use(piniaPersist)

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
})

createApp(App).use(pinia).use(vuetify).use(PrimeVue).use(router).use(ToastService).mount('#app')
